export const MAIN_CLASS_NAME = 'ib-form-field-label';
